<template>
    <div class="bg">
      <div class="contrainer">
        <img src="../assets/images/touming.png">
        <div class="login-wrap animated flipInY">
          <!-- <h3>注册</h3> -->
          <el-form ref="form" :rules="rules" :model="form" label-width="0">
            <el-form-item label="" prop="userName">
              <el-input v-model="form.userName" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item label="" prop="number">
              <el-input v-model="form.number" placeholder="员工编号"></el-input>
            </el-form-item>
            <el-form-item label="" prop="email"
            :rules="[
              { required: true, message: '请输入邮箱地址', trigger: 'blur' },
              { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
            ]"
            >
              <el-input v-model="form.email" placeholder="邮箱">
                <el-button v-show="show" slot="append" @click="getVerification">获取验证码</el-button>
                <el-button v-show="!show" slot="append">{{ count }}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="code">
              <el-input v-model="form.code" placeholder="验证码"></el-input>
            </el-form-item>
            <el-form-item label="" prop="password1">
              <el-input v-model="form.password1" placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item label="" prop="password2">
              <el-input v-model="form.password2" placeholder="确认密码"></el-input>
            </el-form-item>
            <el-form-item class="butt">
              <el-button type="primary" @click="handleRegister('form')">注册</el-button>
              <span @click="backLogin" style="color:#5689ff;cursor:pointer;">返回登录</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
        <vue-particles
            color="#fff"
            :particleOpacity="0.7"
            :particlesNumber="30"
            shapeType="star"
            :particleSize="5"
            linesColor="#fff"
            :linesWidth="2"
            :lineLinked="true"
            :lineOpacity="0.4"
            :linesDistance="150"
            :moveSpeed="3"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="true"
            clickMode="push"
        >
        </vue-particles>
    </div>
</template>
<script>
export default {
    name: 'login',
    data(){
      var validatePass1 = (rule, value, callback) => {
       const age= /^[0-9a-zA-Z]{6,16}$/;
        if (!age.test(value)) {
          callback(new Error('格式不正确，规则：6~16个字符，区分大小写。'));
        }else{
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.password1) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validateName = (rule, value, callback) => {
        let params = {
              loginName: value,
          };
          params = this.$qs.stringify(params,{ indices: false });
          this.axios({
              method:'post',
              url:window.API_HOST+'/login/checkName',
              data:params
          }).then((res)=>{
            this.userNameData = res.data.status;
            if (value == '') {
              callback(new Error('请输入用户名'));
            } else if (this.userNameData == '500') {
              callback(new Error('用户名已存在'));
            } else {
              callback();
            }
        })
      };
      var validateNumber = (rule, value, callback) => {
        const age= /^[A-Za-z]{3}[0-9]{4}$/;
        if(value === ''){
          callback();
        }else if (!age.test(value)) {
          callback(new Error('格式不正确，例:“BIL1100”'));
        }else{
          callback();
        }
      };
      var validateCode = (rule, value, callback) => {
        const age= /^[0-9a-zA-Z]{4}$/;
        if (!age.test(value)) {
          callback(new Error('格式不正确，例:“ss11”'));
        }else{
          callback();
        }
      };
      
      return{
        isMemery:false,
        form: {
          userName: '',
          number: '',
          email: '',
          code: '',
          password1: '',
          password2: '',
        },
        rules: {
          userName: [
            { required: true, validator: validateName,  trigger: 'blur' },
          ],
          number: [
            {  validator: validateNumber, trigger: 'blur' },
          ],
          code: [
            { required: true, validator: validateCode, trigger: 'blur' },
          ],
          password1: [
            { required: true, validator: validatePass1,  trigger: 'blur' },
          ],
          password2: [
            { required: true, validator: validatePass2, trigger: 'blur' }
          ]
        },
        emailNumber: '',
        show: true,
        count: '',
        timer: null,
        userNameData: ''
      }
    },
    methods:{
      handleRegister(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let params = {
                loginName: this.form.userName,
                password: this.form.password1,
                number: this.form.number,
                email: this.form.email,
            };
            if(this.form.code.toUpperCase() == this.emailNumber.toUpperCase()){
              params = this.$qs.stringify(params,{ indices: false });
              this.axios({
                  method:'post',
                  url:window.API_HOST+'/login/register',
                  data:params
              }).then((res)=>{
                if(res.data.status == 200){
                  this.$message({
                    message: res.data.msg,
                    type: 'success'
                  });
                  this.$router.push({
                    path:'/login'
                  });
                }else{
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  });
                }
              });
            }else{
              this.$message({
                message:'验证码填写错误,请重新填写',
                type:'warning'
              });
            }
          }
        })
      },
      //获取验证码
        getVerification(){
          if(this.form.email == ''){
            this.$message({
                message:'请输入邮箱',
                type:'warning'
            })
          }
          else{
            let params = {
              email:this.form.email,
              type: '1' //1代表是注册
            };
            params = this.$qs.stringify(params,{ indices: false });
            this.axios({
              method:'post',
              url:window.API_HOST+'/login/sendCode',
              data:params,
            }).then((res)=>{ 
              console.log(res.data);
              if(res.data.status == 200){
                  const TIME_COUNT = 60;
                  if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.show = false;
                    this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                      } else {
                      this.show = true;
                      clearInterval(this.timer);
                      this.timer = null;
                      }
                    }, 1000)
                  }
                  this.$message({
                      message:res.data.msg,
                      type:'success'
                  });
                  this.emailNumber = res.data.data;
              }else{
                this.$message({
                  message:res.data.msg,
                  type:'warning'
                });
              }
            });
          }
        },
        backLogin(){
          this.$router.push({
            path: '/login'
          })
        }
        //验证用户名
      //   verifyUsername(){
      //     console.log(111);
      //     let params = {
      //         loginName: this.form.userName,
      //     };
      //     params = this.$qs.stringify(params,{ indices: false });
      //     this.axios({
      //         method:'post',
      //         url:window.API_HOST+'/login/checkName',
      //         data:params
      //     }).then((res)=>{
      //       console.log(res.data);
      //       this.userNameData = res.data.status;
      //       this.$message({
      //         message:this.userNameData,
      //         type:'warning'
      //       });
           
      //   })
      // },

  },
}
</script>
<style scoped lang="scss">
.contrainer{
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 16%;
    align-items: flex-end;
}
/deep/ .el-input__inner{
    -webkit-appearance: none;
    background-color: black !important;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: white;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}
.bg {
    position: relative;
    overflow: hidden;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('../assets/images/sky.jpg');
    background-position: -20% 10%;
    background-size: contain;
    #particles-js {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
}
.login-wrap {
  width: 97% !important;
  padding: 0 27px 0 20px;
  z-index: 3;
  .el-form-item {
    margin-bottom: 20px !important;
  }
  h3 {
    text-align: center;
    color: #43464a;
    margin-top: 0px;
    margin-bottom: 5px;
    span {
        color: #20a0ff;
    }
  }
  form {
    width: 100%;
    margin: 10px auto;
    .el-form-item {
      margin-bottom: 15px;
      /deep/ .el-input-group__append, .el-input-group__prepend{
        background-color: black !important;
        color: #5689ff !important;
        font-size: 12px;
        padding: 10px;
      }
    }
  }
  a {
    text-decoration: none;
    color: #1f2d3d;
  }
  button {
    width: 100%;
    font-weight: 600;
  }
}
/deep/ .el-form-item__label{
  color:#43464a;
  font-size: 14px !important;
}
.butt{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /deep/ .el-form-item__content{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0 !important;
    flex-direction: column;
  }
}
.imgSrc{
  width: 35px;
  height: 35px;
  margin: 0 0 -8px 10px;
}
/deep/ input::-webkit-input-placeholder {
color: #757575;
}
/deep/ input::-moz-input-placeholder {
color: #757575;
}
/deep/ input::-ms-input-placeholder {
color: #757575;
}
</style>
